import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { Course } from 'src/app/models/course';
import { FileService } from 'src/app/services/file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  public record:any=[];
  public recordBlog:any=[];
  public loading:boolean=true;
  public disabledId:number=0;
  public years:any=[];
  public status:string='all';
  public year:string='0';

  constructor(
    private _acc: AccountService,
    private _file: FileService
  ) {}

  ngOnInit() {
    this.getUserCPDRecord();
    this.getUserCPDBlogRecord();
  }

  public getUserCPDRecord(){
    this._acc.getCPDRecord().subscribe(
      (res:any)=>{
        this.record=Object.keys(res).map(it => res[it]);
        this.loading=false;
        this.parseYears();
      }
    );
  }

  public getUserCPDBlogRecord(){
    this._acc.getCPDBlogRecord().subscribe(
      (res:any)=>{
        this.recordBlog=Object.keys(res).map(it => res[it]);
        this.parseYearsBlog();
      }
    );
  }

  private parseYears(){
    this.record.forEach(rec=>{
      if(rec.complete_year) {
        if(this.years.indexOf(rec.complete_year) === -1) {
          this.years.push(rec.complete_year);
        }
      }
    });
    this.years.sort();
  }

  private parseYearsBlog(){
    this.recordBlog.forEach(rec=>{
      if(rec.complete_year) {
        if(this.years.indexOf(rec.complete_year) === -1) {
          this.years.push(rec.complete_year);
        }
      }
    });
    this.years.sort();
  }

  public downloadCertificate(courseId:number){
    this.disabledId=courseId;
    this._file.downloadFile(`/api/course/certificate/${courseId}`).subscribe(data=>{
      let url = window.URL.createObjectURL(data);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download ='certificate.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.disabledId=0;
    });

  }

  downloadCertificate2(courseId:number){
    this.disabledId=courseId;
    window.open(environment.apiEndpoint+'/certificatedownload/'+courseId+'/'+localStorage.getItem('token'), '_blank');
    this.disabledId=0;
  }
}
